<template>
<div class="scoreboard-wallet-supplier">
	<!-- Row 1: Balance Metrics -->
	<div class="inventory-summaries row mb-3">
		<!-- Available Balance -->
		<div class="col-md-3 col-lg-3">
			<div class="box">
				<div class="">
					<div class="d-flex justify-content-between align-items-center">
						<h3
							class="text-success font-weight-bold mb-0"
							:class="{ 'is-loading': isFetchingBalance }">
							<span>{{ balanceDisplay }}</span>
						</h3>
						<i class="material-icons cursor-help" v-tooltip="'Saldo yang bisa ditarik ke rekening Anda saat ini.'">info</i>
					</div>
					<div class="d-flex justify-content-between align-items-center">
						<span>{{ $t('Available Balance') }}</span>
					</div>
				</div>
			</div>
		</div>

		<!-- On Process Withdrawals -->
		<div class="col-md-3 col-lg-3">
			<div class="box">
				<div class="">
					<div class="d-flex justify-content-between align-items-center">
						<h3
							class="text-warning font-weight-bold mb-0"
							:class="{ 'is-loading': isFetchingWithdrawals }">
							<span>{{ withdrawnDisplay }}</span>
						</h3>
						<i class="material-icons cursor-help" v-tooltip="'Withdraw yang sedang diproses oleh tim Finance Ostock.'">info</i>
					</div>
					<div class="d-flex justify-content-between align-items-center">
						<span>On Process Withdrawals</span>
					</div>
				</div>
			</div>
		</div>

		<!-- Completed Withdrawals -->
		<div class="col-md-3 col-lg-3">
			<div class="box">
				<div class="">
					<div class="d-flex justify-content-between align-items-center">
						<h3
							class="text-info font-weight-bold mb-0"
							:class="{ 'is-loading': isFetchingTotalWithdrawal }">
							<span>{{ formatNumber(totalWithdrawal) }}</span>
						</h3>
						<i class="material-icons cursor-help" v-tooltip="'Total penarikan dana yang sudah berhasil diselesaikan sepanjang waktu.'">info</i>
					</div>
					<div class="d-flex justify-content-between align-items-center">
						<span>Completed Withdrawals</span>
					</div>
				</div>
			</div>
		</div>

		<!-- Stash Total -->
		<div class="col-md-3 col-lg-3">
			<div class="box">
				<div class="">
					<div class="d-flex justify-content-between align-items-center">
						<h3
							class="text-warning font-weight-bold mb-0"
							:class="{ 'is-loading': isFetchingStash }">
							<span>{{ stashDisplay }}</span>
						</h3>
						<i class="material-icons cursor-help" v-tooltip="'Dana pending yang sedang direkonsiliasi oleh tim finance sebelum ditambahkan ke saldo utama.'">info</i>
					</div>
					<div class="d-flex justify-content-between align-items-center">
						<span>Stash Total</span>
						<router-link to="/credits/stash" class="text-primary">View All</router-link>
					</div>
				</div>
			</div>
		</div>
	</div>

	<!-- Row 2: Revenue Performance -->
	<div class="revenue-performance-wrapper">
		<div class="d-lg-flex align-items-center mb-3">
			<!-- Section Title -->
			<h4 class="mb-0 mr-3">Revenue Performance</h4>

			<!-- Date Filter -->
			<div class="table-filters d-flex align-items-center ml-a">
				<daterangepicker
					:presets="filterDatePresets"
					:start="since"
					:end="until"
					@selected="setFilterDate">
				</daterangepicker>
			</div>
		</div>

		<div class="inventory-summaries row">
			<!-- Total Revenue -->
			<div class="col-md-3 col-lg-3">
				<div class="box">
					<div class="">
						<div class="d-flex justify-content-between align-items-center">
							<h3
								class="text-success font-weight-bold mb-0"
								:class="{ 'is-loading': isFetchingScoreboard }">
								<span>{{ formatNumber(scoreboardData.total_revenue) }}</span>
							</h3>
							<i class="material-icons cursor-help" v-tooltip="'Total pendapatan dari semua transaksi pada periode yang dipilih.'">info</i>
						</div>
						<div class="d-flex justify-content-between align-items-center">
							<span class="text-bold">Total Revenue</span>
						</div>
					</div>
				</div>
			</div>

			<!-- Product Sales -->
			<div class="col-md-3 col-lg-3">
				<div class="box">
					<div class="">
						<div class="d-flex justify-content-between align-items-center">
							<h3
								class="text-primary font-weight-bold mb-0"
								:class="{ 'is-loading': isFetchingScoreboard }">
								<span>{{ formatNumber(scoreboardData.product_sales) }}</span>
							</h3>
							<i class="material-icons cursor-help" v-tooltip="'Total nilai penjualan produk.'">info</i>
						</div>
						<div class="d-flex justify-content-between align-items-center">
							<span>Product Sales</span>
						</div>
					</div>
				</div>
			</div>

			<!-- Handling Fee -->
			<div class="col-md-3 col-lg-3">
				<div class="box">
					<div class="">
						<div class="d-flex justify-content-between align-items-center">
							<h3
								class="text-danger font-weight-bold mb-0"
								:class="{ 'is-loading': isFetchingScoreboard }">
								<span>{{ formatNumber(scoreboardData.handling_fee) }}</span>
							</h3>
							<i class="material-icons cursor-help" v-tooltip="'-'">info</i>
						</div>
						<div class="d-flex justify-content-between align-items-center">
							<span>Handling Fee</span>
						</div>
					</div>
				</div>
			</div>

			<!-- Completed Withdrawals (Filtered) -->
			<div class="col-md-3 col-lg-3">
				<div class="box">
					<div class="">
						<div class="d-flex justify-content-between align-items-center">
							<h3
								class="text-info font-weight-bold mb-0"
								:class="{ 'is-loading': isFetchingScoreboard }">
								<span>{{ formatNumber(scoreboardData.completed_withdrawals) }}</span>
							</h3>
							<i class="material-icons cursor-help" v-tooltip="'Total dana yang berhasil ditarik ke rekening pada periode yang difilter.'">info</i>
						</div>
						<div class="d-flex justify-content-between align-items-center">
							<span>Completed Withdrawals</span>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
</template>

<script>
import { mapGetters } from 'vuex';
import dayjs from 'dayjs';
import Daterangepicker from '@/components/Daterangepicker.vue';
import { duplicateVar, getDateRange, formatNumberPlain } from '@/lib/helper';
import walletApi from '@/api/wallet';
import walletStashApi from '@/api/wallet-stash';

const defaultFilterDate = getDateRange();

export default {
	name: 'ScoreboardWalletSupplier',
	components: {
		Daterangepicker,
	},
	props: {
		user: {
			type: Object,
			required: true,
		},
	},
	data() {
		return {
			filterDate: defaultFilterDate,
			isFetchingBalance: false,
			isFetchingWithdrawals: false,
			isFetchingStash: false,
			isFetchingScoreboard: false,
			isFetchingTotalWithdrawal: false,
			balance: 0,
			withdrawn: 0,
			stashTotal: 0,
			totalWithdrawal: 0,
			scoreboardData: {
				total_revenue: 0,
				product_sales: 0,
				handling_fee: 0,
				completed_withdrawals: 0,
			},
		};
	},
	computed: {
		...mapGetters({
			filterDatePresets: 'filterDatePresets',
		}),
		since() {
			const since = this.$route.query.since;
			return since;
		},
		until() {
			const until = this.$route.query.until;
			return until;
		},
		balanceDisplay() {
			return formatNumberPlain(this.balance);
		},
		withdrawnDisplay() {
			return formatNumberPlain(this.withdrawn);
		},
		stashDisplay() {
			return formatNumberPlain(this.stashTotal);
		},
	},
	methods: {
		formatNumber(number) {
			return formatNumberPlain(number);
		},
		initFilterDate() {
			if (this.since && this.since !== '' && this.until && this.until !== '') {
				const format = 'YYYY-MM-DD';
				const since = dayjs(this.since).format(format);
				const until = dayjs(this.until).format(format);
				const filterDate = {
					start: since,
					end: until,
				};
				this.filterDate = filterDate;
			}
		},
		setFilterDate(filterDate) {
			this.filterDate = filterDate;
			const since = dayjs(filterDate.start).format('YYYY-MM-DD');
			const until = dayjs(filterDate.end).format('YYYY-MM-DD');
			const query = duplicateVar(this.$route.query);
			query.since = since;
			query.until = until;
			this.$router.push({ query });
			this.fetchScoreboard();
		},
		getBalance() {
			this.isFetchingBalance = true;
			const callback = (response) => {
				this.isFetchingBalance = false;
				const wallet = response.data;
				this.balance = wallet.balance;
			};
			const errorCallback = (e) => {
				this.isFetchingBalance = false;
				console.error('Error fetching balance:', e);
			};
			walletApi.getBalance(callback, errorCallback);
		},
		getOnProcessWithdrawal() {
			this.isFetchingWithdrawals = true;
			const callback = (response) => {
				const total = response.data;
				this.withdrawn = total;
				this.isFetchingWithdrawals = false;
			};
			const errorCallback = (e) => {
				console.error('Error fetching on process withdrawals:', e);
				this.isFetchingWithdrawals = false;
			};
			walletApi.getOnProcessWithdrawal(callback, errorCallback);
		},
		getStashBalance() {
			this.isFetchingStash = true;
			const callback = (response) => {
				this.isFetchingStash = false;
				const total = response.data;
				this.stashTotal = total;
			};
			const errorCallback = (e) => {
				this.isFetchingStash = false;
				console.error('Error fetching stash balance:', e);
			};
			walletStashApi.getTotal(callback, errorCallback);
		},
		fetchScoreboard() {
			this.isFetchingScoreboard = true;
			const dateFormat = 'YYYY-MM-DD';
			const startDate = dayjs(this.filterDate.start).format(dateFormat);
			const endDate = dayjs(this.filterDate.end).format(dateFormat);
			const params = {
				since: startDate,
				until: endDate,
			};
			const callback = (response) => {
				this.isFetchingScoreboard = false;
				const data = response.data;
				this.scoreboardData = data;
			};
			const errorCallback = (e) => {
				this.isFetchingScoreboard = false;
				console.error('Error fetching scoreboard:', e);
			};
			walletApi.getSupplierScoreboard(params, callback, errorCallback);
		},
		getTotalWithdrawal() {
			this.isFetchingTotalWithdrawal = true;
			const callback = (response) => {
				this.isFetchingTotalWithdrawal = false;
				const total = response.data;
				this.totalWithdrawal = total;
			};
			const errorCallback = (e) => {
				this.isFetchingTotalWithdrawal = false;
				console.error('Error fetching total withdrawal:', e);
			};
			walletApi.getTotalWithdrawal(callback, errorCallback);
		},
		init() {
			this.initFilterDate();
			this.getBalance();
			this.getOnProcessWithdrawal();
			this.getStashBalance();
			this.getTotalWithdrawal();
			this.fetchScoreboard();
		},
	},
	watch: {
		user() {
			this.init();
		},
	},
	mounted() {
		if (this.user) {
			this.init();
		}
	},
};
</script>

<style scoped>
.cursor-help {
	cursor: help;
}
</style>
